const ns = {};

ns.dateToInput = (date, type, seconds) =>
{
    let dateString = date.getFullYear() + "-" + 
        (("0" + (date.getMonth() + 1)).slice(-2)) + "-" +
        (("0" + (date.getDate())).slice(-2)) + " " + 
        (("0" + (date.getHours())).slice(-2)) + ":" +
        (("0" + (date.getMinutes())).slice(-2));

    if (seconds) 
    {
        dateString += ":" + (("0" + (date.getSeconds())).slice(-2));
    }

    if (type)
    {
        switch(type)
        {
            case "date":
                dateString = dateString.split(" ")[0];
                break;

            case "time":
                dateString = dateString.split(" ")[1];
                break;
        }
    }

    return dateString;
};

ns.getDateRange = (type) =>
{
    let temp = new Date();
    let str = "";
    let end = "";

    switch ((type + "").toLowerCase())
    {
        case "yesterday":
            temp.setDate(temp.getDate() - 1);
            str = ns.dateToInput(temp, Helper.DateFormat_Date);
            end = ns.dateToInput(temp, Helper.DateFormat_Date);
            break;

        case "this week":
            temp.setDate(temp.getDate() - temp.getDay());
            str = ns.dateToInput(temp, Helper.DateFormat_Date);
            temp.setDate(temp.getDate() + 6);
            end = ns.dateToInput(temp, Helper.DateFormat_Date);
            break;

        case "last week":
            temp.setDate((temp.getDate() - temp.getDay()) - 7);
            str = ns.dateToInput(temp, Helper.DateFormat_Date);
            temp.setDate(temp.getDate() + 6);
            end = ns.dateToInput(temp, Helper.DateFormat_Date);
            break;

        case "this month":
            temp.setDate(1);
            str = ns.dateToInput(temp, Helper.DateFormat_Date);
            temp.setMonth(temp.getMonth() + 1);
            temp.setDate(temp.getDate() - 1);
            end = ns.dateToInput(temp, Helper.DateFormat_Date);
            break;

        case "last month":
            temp.setDate(1);
            temp.setMonth(temp.getMonth() - 1);
            str = ns.dateToInput(temp, Helper.DateFormat_Date);
            temp.setMonth(temp.getMonth() + 1);
            temp.setDate(temp.getDate() - 1);
            end = ns.dateToInput(temp, Helper.DateFormat_Date);
            break;

        case "today":
        default:
            str = ns.dateToInput(temp, Helper.DateFormat_Date);
            end = ns.dateToInput(temp, Helper.DateFormat_Date);
            break;
    }

    return [str, end];
}

ns.compare = (par1, par2) =>
{
    // TODO
};

ns.inputToDate = (inp) =>
{

};

// TODO - create ASYNC versions ...
ns.toJson = (data) =>
{
    return JSON.stringify(data);  
};

ns.fromJson = (json) =>
{
    return JSON.parse(json);  
};

ns.fromUrlParams = (params) =>
{
    if (!params) {
        return {};
    }

    // THIS DOES NOT WORK FOR ARRAYS...
    let json = '{"' + decodeURI(params.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}';
    return JSON.parse(json);
}

ns.toUrlParams = (obj) =>
{
    let str = "";
    for (let p in obj)
    {
        str += p + "=" + obj[p] + "&";
    }
    str = str.substring(0, str.length - 1);
    return str;
};

ns.copy = (data) =>
{
    return ns.deserialize(
        ns.serialize(data)
    );
};


ns.serialize = (data, level) =>
{
    let typ = ns.getType(data);
    let ret = { t: typ };
    level = level || 0;

    if (typ === "Object")
    {
        let tmp = {};
        for (let p in data)
        {
            tmp[p] = ns.serialize(data[p], level + 1);
        }
        ret.v = tmp;
    }

    else if (typ === "Array") 
    {
        let tmp = [];
        for (let i = 0; i < data.length; i++)
        {
            tmp.push(ns.serialize(data[i], level + 1));
        }
        ret.v = tmp;
    }

    else 
    {
        ret.v = data;
    }

    return (level == 0) ? JSON.stringify(ret) : ret;
};


ns.deserialize = (text, level) =>
{
    let data;
    level = level || 0;

    try 
    {
        data = level < 1 ? JSON.parse(text) : text;
    } 
    
    catch (ignore)
    {
        return undefined;
    }

    if (!data || !data.t)
    {
        console.debug("missing t", data);
        return undefined;
    }

    switch (data.t)
    {
        case "Date":
            return new Date(data.v);
        
        case "Number":
            return Number(data.v);

        case "Null":
            return null;

        case "Undefined":
            return undefined;

        case "Object": 
            {
                let ret = {};
                for (let p in data.v)
                {
                    ret[p] = ns.deserialize(data.v[p], level + 1);
                }
                return ret;
            }

        case "Array":
            {
                let ret = [];
                for (let i = 0; i < data.v.length; i++)
                {
                    ret.push(ns.deserialize(data.v[i], level + 1));
                }
                return ret;
            }

        case "String":
        default:
            return data.v + "";
    }
};

ns.getType = (obj) =>
{
    let str = Object.prototype.toString.apply(obj).substring(8);
    return str.substring(0, str.length - 1);
};

export default ns;